import React from 'react';
import PropTypes from 'prop-types';

import { amountFormater } from '../ManagePaymentListing/ColumnFormater';
import PaymentDetailsContainer from './PaymentDetailsContainer';
import { directDebitPropTypes } from '../../../states/managePayments/propTypes';
import PaymentDetailsTable from './PaymentDetailsTable';
import { formatAccountToView } from '../../../utils/accountUtils';

export const DirectDebitDetails = ({ mandate, content }) => {
	const { fromLabel, toLabel, lastAmountLabel, lastPaidLabel, lastPaymentReferenceLabel } = content;

	const { to, amount, when, reference, fromAccount } = mandate;
	const tableRowMapping = {
		[fromLabel]: formatAccountToView(fromAccount),
		[toLabel]: to,
		[lastAmountLabel]: amountFormater({ amount }),
		[lastPaidLabel]: when,
		[lastPaymentReferenceLabel]: reference,
	};
	return <PaymentDetailsTable tableRowMapping={tableRowMapping} />;
};

export default PaymentDetailsContainer(DirectDebitDetails);

DirectDebitDetails.propTypes = {
	mandate: PropTypes.shape(directDebitPropTypes),
	content: PropTypes.shape({}),
};
